import apiClient from "../lib/apiClient";
import type { PageResponse } from "./types";

export interface LieuMiniInArtistResponse {
  id: string;
  name: string;
  addressName?: string;
}

export interface ArtistDto {
  name: string;
  description?: string;
  photoLink?: string;
  lieuIds?: string[];
}

export interface ArtistResponse {
  id: string;
  tenantId: string;
  name: string;
  description?: string;
  photoLink?: string;
  lieux?: LieuMiniInArtistResponse[];
  createdAt: string;
  updatedAt: string;
}

export interface ArtistSearchParams {
  search?: string;
  page?: number;
  size?: number;
  sort?: string;
}

export async function listArtists(params: ArtistSearchParams) {
  const { data } = await apiClient.get<PageResponse<ArtistResponse>>("/parcours-artist", { params });
  return data;
}

export async function getArtist(id: string) {
  const { data } = await apiClient.get<ArtistResponse>(`/parcours-artist/${id}`);
  return data;
}

export async function createArtist(dto: ArtistDto) {
  const { data } = await apiClient.post<ArtistResponse>("/parcours-artist", dto);
  return data;
}

export async function updateArtist(id: string, dto: ArtistDto) {
  const { data } = await apiClient.put<ArtistResponse>(`/parcours-artist/${id}`, dto);
  return data;
}

export async function deleteArtist(id: string) {
  await apiClient.delete(`/parcours-artist/${id}`);
}
